import Vue from "vue"
import VueRouter from "vue-router"
Vue.use(VueRouter)

import Layout from "@/layout"
import { path } from "d3"

/**
 * hidden:导航栏是否隐藏
 * alwaysShow:根节点是否显示
 * title: 页面标题
 * icon： 页面图标
 * affix：页面是否固定在标签栏
 * newWindow：点击菜单时是否在新窗口打开（true 时不占用当前标签页）
 */
export const constantRoutes = [
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/views/redirect/index")
      }
    ]
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login.vue"),
    hidden: true,
    meta: { title: "登录" }
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import("@/views/logout.vue"),
    hidden: true,
    meta: { title: "登出..." }
  },
  {
    path: "/404",
    component: () => import("@/views/error-page/404"),
    hidden: true
  },
  // {
  //  path: '/',
  //  component: () => import("@/views/home/my-home.vue"),
  //   meta: {
  //     title: "首页",
  //     icon: "home"
  //   }
  // },
  // {
  //   path: "/",
  //   redirect: "/home",
  //   component: Layout,
  //   meta: { title: "首页", icon: "home" },
  //   // alwaysShow: true,
  //   hidden: true,
  //   children: [
  //     {
  //       path: "site-spread",
  //       name: "SiteSpread",
  //       component: () => import("../views/home/site-spread.vue"),
  //       meta: {
  //         title: "台区分布",
  //         icon: "dot"
  //       }
  //     },
  //     {
  //       path: "home",
  //       name: "home",
  //       component: () => import("../views/home/my-home.vue"),
  //       meta: {
  //         title: "首页",
  //         icon: "dot"
  //       }
  //     }
  //   ]
  // },

  {
    path: "/",
    redirect: "/home",
    component: Layout,
    meta: { title: "首页", icon: "home" },
    children: [
      {
        path: "home",
        name: "Home",
        component: () => import("../views/home/my-home.vue"),
        meta: { title: "首页", icon: "home" },
      }
    ]
  },

  // ===== 数据大屏（点击左侧菜单，浏览器新开窗口展示，不带系统布局） =====
  {
    path: "/data-screen",
    name: "DataScreen",
    component: () => import("../views/data_screen/index.vue"),
    meta: { title: "数据大屏", icon: "dashboard", newWindow: true, noCache: true }
  }

]

//权限路由路径映射
export const mappingPath = {
  "/index": {
    path: "/index",
    redirect: "/index/site-spread",
    component: Layout,
    meta: { title: "首页", icon: "home" }
  },
  "/site-spread": {
    path: "site-spread",
    name: "SiteSpread",
    component: () => import("../views/home/site-spread"),
    meta: { title: "站点分布", icon: "dot" }
  },

  //统计分析3
  "/dev-data": {
    path: "/dev-data",
    redirect: "/dev-data/dev-online",
    component: Layout,
    meta: { title: "设备监测", icon: "dev-data" }
  },

  //订单管理
  "/order": {
    path: "/order",
    redirect: "/order/use-elec-log",
    component: Layout,
    meta: { title: "订单管理", icon: "record" },
    alwaysShow: true
  },

  "/month-report": {
    path: "month-report",
    name: "monthReport",
    component: () => import("../views/log/send-log.vue"),
    meta: { title: "月报表", icon: "dot" }
  },
  //数据统计
  "/statistics_data": {
    path: "/statistics_data",
    redirect: "/statistics_data/statistics-use",
    component: Layout,
    meta: { title: "事件记录", icon: "record" },
    alwaysShow: true
  },
  "/statistics-use": {
    path: "statistics-use",
    name: "StatisticsUse",
    component: () => import("../views/statistics_data/statistics-use.vue"),
    meta: { title: "用电量统计", icon: "dot" }
  },
  //日志管理
  "/log": {
    path: "/log",
    redirect: "/log/running-log",
    component: Layout,
    meta: { title: "事件记录", icon: "record" },
    alwaysShow: true
  },
  "/running-log": {
    path: "running-log",
    name: "RunningLog",
    component: () => import("../views/log/running-log.vue"),
    meta: { title: "设备运行日志", icon: "dot" }
  },
  "/send-log": {
    path: "send-log",
    name: "sendLog",
    component: () => import("../views/log/send-log.vue"),
    meta: { title: "短信推送日志", icon: "dot" }
  },

  "/charging-config-send-log": {
    path: "charging-config-send-log",
    name: "charging-config-send-log",
    component: () => import("../views/log/charging-config-send-log.vue"),
    meta: { title: "计费模型发送记录", icon: "dot" }
  },
  "/sms-send-log": {
    path: "sms-send-log",
    name: "sms-send-log",
    component: () => import("../views/log/sms-send-log.vue"),
    meta: { title: "短信发送记录", icon: "dot" }
  },
  "/dev-alarm-log": {
    path: "dev-alarm-log",
    name: "DevAlarmLog",
    component: () => import("../views/log/dev-alarm-log.vue"),
    meta: { title: "故障告警", icon: "dot" }
  },
  "/ctr_strate_log": {
    path: "ctr_strate_log",
    name: "Ctrstratelog",
    component: () => import("../views/log/ctr_strate_log.vue"),
    meta: { title: "调控记录", icon: "dot" }
  },

  //设备管理5
  "/dev_archive": {
    path: "/dev_archive",
    name: "dev_archive",
    component: Layout,
    redirect: "/dev_archive/street-manage",
    meta: { title: "设备管理", icon: "dev_archive" }
  },
  "/street-manage": {
    path: "street-manage",
    name: "streetManage",
    component: () => import("../views/dev_archive/street-manage.vue"),
    meta: { title: "街道管理", icon: "dot" }
  },
  "/community-manage": {
    path: "community-manage",
    name: "communitymanage",
    component: () => import("../views/dev_archive/community-manage.vue"),
    meta: { title: "社区管理", icon: "dot" }
  },

  "/power-site-manage": {
    path: "power-site-manage",
    name: "powersitemanage",
    component: () => import("../views/dev_archive/power-site-manage.vue"),
    meta: { title: "站点管理", icon: "dot" }
  },

  "/power-transformer-manage": {
    path: "power-transformer-manage",
    name: "powertransformermanage",
    component: () => import("../views/dev_archive/power-transformer-manage.vue"),
    meta: { title: "台区管理", icon: "dot" }
  },

  "/ks-device-manage": {
    path: "ks-device-manage",
    name: "KSDeviceManage",
    component: () => import("../views/dev_archive/ks-device-manage.vue"),
    meta: { title: "KS终端管理", icon: "dot" }
  },
  "/power-cabinet-manage": {
    path: "power-cabinet-manage",
    name: "powercabinetmanage",
    component: () => import("../views/dev_archive/power-cabinet-manage.vue"),
    meta: { title: "一体柜管理", icon: "dot" }
  },
  "/branch-box-manage": {
    path: "branch-box-manage",
    name: "branchboxmanage",
    component: () => import("../views/dev_archive/branch-box-manage.vue"),
    meta: { title: "分支箱管理", icon: "dot" }
  },
  "/pub-charge-pile-channel": {
    path: "pub-charge-pile-channel",
    name: "PubChargePileChannel",
    component: () => import("../views/dev_archive/pub-charge-pile-channel.vue"),
    meta: { title: "公共桩通道", icon: "dot" }
  },
  "/fee-table": {
    path: "fee-table",
    name: "feeTable",
    component: () => import("../views/dev_archive/fee-table.vue"),
    meta: { title: "费控表管理", icon: "dot" },
    hidden: true
  },
  "/charge-pile-manage": {
    path: "charge-pile-manage",
    name: "chargepilemanage",
    component: () => import("../views/dev_archive/charge-pile-manage.vue"),
    meta: { title: "充电桩管理", icon: "dot" }
  },
  "/charge-gun-manage": {
    path: "charge-gun-manage",
    name: "chargegunmanage",
    component: () => import("../views/dev_archive/charge-gun-manage.vue"),
    meta: { title: "充电枪管理", icon: "dot" }
  },
  "/charge-pile-producer-manage": {
    path: "charge-pile-producer-manage",
    name: "chargepileproducermanage",
    component: () => import("../views/dev_archive/charge-pile-producer-manage.vue"),
    meta: { title: "桩厂家管理", icon: "dot" }
  },
  "/upgrade-package": {
    path: "upgrade-package",
    name: "upgradePackage",
    component: () => import("../views/dev_archive/upgrade-package.vue"),
    meta: { title: "设备升级包", icon: "dot" }
  },
  "/change-fee-table": {
    path: "change-fee-table",
    name: "ChangeFeeTable",
    component: () => import("../views/dev_archive/change-fee-table.vue"),
    meta: { title: "换表管理", icon: "dot" }
  },

  //数据监测统计
  "/dev-online": {
    path: "dev-online",
    name: "DevOnline",
    component: () => import("../views/dev_data/dev-online.vue"),
    meta: { title: "设备状态", icon: "dot" }
  },
  "/dev-use-elec": {
    path: "dev-use-elec",
    name: "DevUseElec",
    component: () => import("../views/dev_data/dev-use-elec.vue"),
    meta: { title: "用电记录", icon: "dot" }
  },
  "/feetable_recharge": {
    path: "feetable_recharge",
    name: "DevUseElec",
    component: () => import("../views/dev_data/feetable_recharge.vue"),
    meta: { title: "预充值", icon: "dot" }
  },
  "/feetable_init": {
    path: "feetable_init",
    name: "DevUseElec",
    component: () => import("../views/dev_data/feetable_init.vue"),
    meta: { title: "初装费", icon: "dot" }
  },
  "/dev-charge-order": {
    path: "dev-charge-order",
    name: "DevChargeOrder",
    component: () => import("../views/dev_data/dev-charge-order.vue"),
    meta: { title: "充电订单", icon: "dot" }
  },
  "/dev-balance": {
    path: "dev-balance",
    name: "DevBalance",
    component: () => import("../views/dev_data/dev-balance.vue"),
    meta: { title: "设备余额", icon: "dot" }
  },

  "/transformer-overview": {
    path: "transformer-overview",
    name: "TransformerOverview",
    component: () => import("../views/dev_data/transformer-overview.vue"),
    meta: { title: "台区总览", icon: "dot" }
  },

  /// 数据统计 start
  "/data_statistics": {
    path: "/data_statistics",
    redirect: "",
    component: Layout,
    meta: { title: "数据统计", icon: "control" }
  },
  "/dev_use_elec_statistics": {
    path: "dev_use_elec_statistics",
    name: "dev_use_elec_statistics",
    component: () => import("../views/data_statistics/dev-use-elec-statistics.vue"),
    meta: { title: "用电记录统计", icon: "dot" }
  },
  "/dev_charge_order_statistics": {
    path: "dev_charge_order_statistics",
    name: "dev_charge_order_statistics",
    component: () => import("../views/data_statistics/dev-charge-order-statistics.vue"),
    meta: { title: "充电订单统计", icon: "dot" }
  },

  /// 数据统计 end
  //功率调控
  "/control": {
    path: "/control",
    redirect: "",
    component: Layout,
    meta: { title: "功率调控", icon: "control" }
  },
  "/special_control_pile": {
    path: "special_control_pile",
    name: "special_control_pile",
    component: () => import("../views/control/special_control_pile.vue"),
    meta: { title: "充电桩柔控", icon: "dot" }
  },
  "/timely_control_branchbox": {
    path: "timely_control_branchbox",
    name: "timely_control_branchbox",
    component: () => import("../views/control/timely_control_branchbox.vue"),
    meta: { title: "分支箱时控", icon: "dot" }
  },
  "/timely_control_cabinet": {
    path: "timely_control_cabinet",
    name: "timely_control_cabinet",
    component: () => import("../views/control/timely_control_cabinet.vue"),
    meta: { title: "一体柜时控", icon: "dot" }
  },

  "/strate-alarm-param-cabinet": {
    path: "strate-alarm-param-cabinet",
    name: "StratealarmparamCabinet",
    component: () => import("../views/setting/strate-alarm-param-cabinet.vue"),
    meta: { title: "一体柜阈值设置", icon: "dot" }
  },

  "/strate-alarm-param-transformer": {
    path: "strate-alarm-param-transformer",
    name: "StratealarmparamTransformer",
    component: () => import("../views/setting/strate-alarm-param-transformer.vue"),
    meta: { title: "台区阈值设置", icon: "dot" }
  },

  "/regulation-details": {
    path: "regulation-details",
    name: "RegulationDetails",
    component: () => import("../views/control/regulation-details.vue"),
    meta: { title: "调控明细", icon: "dot" }
  },

  //系统管理8
  "/user": {
    path: "/user",
    redirect: "/user/user-manager",
    component: Layout,
    meta: { title: "系统管理", icon: "setting" }
  },
  "/group-manage": {
    path: "groupManage",
    name: "GroupManage",
    component: () => import("../views/user/group-manage.vue"),
    meta: { title: "商户管理", icon: "dot" }
  },
  "/user-manager": {
    path: "user-manager",
    name: "UserManager",
    component: () => import("../views/user/user-manager.vue"),
    meta: { title: "用户管理", icon: "dot" }
  },
  "/role-manager": {
    path: "role-manager",
    name: "RoleManager",
    component: () => import("../views/user/role-manager.vue"),
    meta: { title: "角色管理", icon: "dot" }
  },
  "/menus-manager": {
    path: "menus-manager",
    name: "MenusManager",
    component: () => import("../views/user/menus-manager.vue"),
    meta: { title: "菜单管理", icon: "dot" }
  },

  "/system-log": {
    path: "system-log",
    name: "SystemLog",
    component: () => import("../views/user/system-log.vue"),
    meta: { title: "系统日志", icon: "dot" }
  },
  "/bmi_merchant": {
    path: "bmi_merchant",
    name: "Bmimerchant",
    component: () => import("../views/user/bmi_merchant.vue"),
    meta: { title: "商户管理", icon: "dot" }
  },
  "/bmi_sub_merchant": {
    path: "bmi_sub_merchant",
    name: "BmiSubMerchant",
    component: () => import("../views/user/bmi_sub_merchant.vue"),
    meta: { title: "子商户管理", icon: "dot" }
  },
  "/jng_wx_user": {
    path: "jng_wx_user",
    name: "Jngwxuser",
    component: () => import("../views/user/jng_wx_user.vue"),
    meta: { title: "商户管理", icon: "dot" }
  },
  "/dict-manage": {
    path: "dict-manage",
    name: "DictManage",
    component: () => import("../views/dict/dict-manage.vue"),
    meta: { title: "字典管理", icon: "dot" }
  },


  "/finance": {
    path: "/finance",
    redirect: "",
    component: Layout,
    meta: { title: "财务管理", icon: "control" }
  },
  "/finance-overview": {
    path: "finance-overview",
    name: "FinanceOverview",
    component: () => import("../views/finance/overview.vue"),
    meta: { title: "财务概览", icon: "dot" }
  },
  "/finance-merchant-info": {
    path: "finance-merchant-info",
    name: "FinanceMerchantInfo",
    component: () => import("../views/finance/merchant_info.vue"),
    meta: { title: "商户信息", icon: "dot" }
  },
  "/finance-merchant-withdrawal": {
    path: "finance-merchant-withdrawal",
    name: "FinanceMerchantWithdrawal",
    component: () => import("../views/finance/merchant_withdrawal.vue"),
    meta: { title: "商户提现", icon: "dot" }
  },
  "/revenue-sharing-ratio-set": {
    path: "revenue-sharing-ratio-set",
    name: "RevenueSharingRatioSet",
    component: () => import("../views/finance/revenue-sharing-ratio-set.vue"),
    meta: { title: "分账比例设置", icon: "dot" }
  },
  "/use-elec-revenue-sharing": {
    path: "use-elec-revenue-sharing",
    name: "UseElecRevenueSharing",
    component: () => import("../views/finance/use-elec-revenue-sharing.vue"),
    meta: { title: "用电记录分账", icon: "dot" }
  },
  "/revenue-sharing-settlement": {
    path: "revenue-sharing-settlement",
    name: "RevenueSharingSettlement",
    component: () => import("../views/finance/revenue-sharing-settlement.vue"),
    meta: { title: "分账结算记录", icon: "dot" }
  },
  "/settlement-pay-record": {
    path: "settlement-pay-record",
    name: "SettlementPayRecord",
    component: () => import("../views/finance/settlement-pay-record.vue"),
    meta: { title: "结算支付记录", icon: "dot" }
  },
  "/init-fee-revenue-sharing": {
    path: "init-fee-revenue-sharing",
    name: "InitFeeRevenueSharing",
    component: () => import("../views/finance/init-fee-revenue-sharing.vue"),
    meta: { title: "初装费分账", icon: "dot" }
  },

  // 查勘管理模块
  "/scan": {
    path: "/scan",
    redirect: "",
    component: Layout,
    meta: { title: "查勘管理", icon: "control" }
  },
  "/project-manage": {
    path: "project-manage",
    name: "PojectManage",
    component: () => import("../views/scan/project_manage.vue"),
    meta: { title: "查勘项目管理", icon: "dot" }
  },
  "/material-manage": {
    path: "material-manage",
    name: "MaterialManage",
    component: () => import("../views/scan/material_manage.vue"),
    meta: { title: "材料施工管理", icon: "dot" }
  },

  /// 安全监测 start
  "/safety_manage": {
    path: "/safety_manage",
    redirect: "",
    component: Layout,
    meta: { title: "安全监测", icon: "control" }
  },
  "/safety_monitoring": {
    path: "safety_monitoring",
    name: "SafetyMonitoring",
    component: () => import("../views/dev_data/safety_monitoring.vue"),
    meta: { title: "安全监测", icon: "dot" }
  },
  "/transformer-detect": {
    path: "transformer-detect",
    name: "TransformerDetect",
    component: () => import("../views/dev_data/transformer-detect.vue"),
    meta: { title: "台区监测", icon: "dot" }
  },

  /// 安全监测 end

}

export const asyncRoutes = []

const createRouter = () =>
  new VueRouter({
    // mode: 'history', // require service support
    scrollBehavior: () => ({
      y: 0
    }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
